import type { EventQueueBoard } from '@shared/index'
import { api } from './http'

export function fetchEventBoard(token: string | null): Promise<EventQueueBoard | { event: null }> {
  return api<EventQueueBoard | { event: null }>('/events/live', {
    ...(token ? { token } : {}),
    quiet: true,
  })
}
